import Journey from '@models/Journey'

export const createJourney = (data) => {
  return Journey.create(data)
}

export const addJourney = (data) => {
  return Journey.insert(data)
}

export const updateJourney = (data) => {
  return Journey.update(data)
}

export const deleteJourney = (filter) => {
  return Journey.delete(filter)
}

export const deleteAllJourneys = () => {
  return Journey.deleteAll()
}
